// src/components/Login.jsx
import { useState } from "react";
import supabase from "../lib/supabase";
import logo from '../assets/company_logo.png';

const Login = ({ initialEmail = "", expired = false }) => {
  const storedEmail = (localStorage.getItem("user_email") || "").trim().toLowerCase();
  const [email, setEmail] = useState(initialEmail || storedEmail);
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const sendMagicLink = async () => {
    const normalizedEmail = email.trim().toLowerCase();
    setError(null);

    if (!normalizedEmail) {
      setError("Please enter a valid email address.");
      return;
    }

    setStatus("Sending magic link...");

    const { error } = await supabase.auth.signInWithOtp({
      email: normalizedEmail,
      options: {
        emailRedirectTo: "https://dashboard-iq.com/auth/callback",
      },
    });

    if (error) {
      setStatus(null);
      setError(error.message);
    } else {
      setStatus("Magic link sent! Check your inbox.");
      localStorage.setItem("user_email", normalizedEmail);
    }
  };

  return (
    <div className="homepage-container">

      <img
        src={logo}
        alt="DashboardIQ Logo"
        className="login-logo"
      />

      <h1 className="homepage-title">
        {expired ? "Session Expired" : "Sign In"}
      </h1>

      <p className="status-message">
        {expired
          ? "Your magic link has expired. Enter your email to receive a new one."
          : "Enter your email to receive a magic link."}
      </p>

      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@example.com"
        className="login-input"
      />

      <button onClick={sendMagicLink} className="login-button">
        Send Magic Link
      </button>

      {status && <p className="status-message">{status}</p>}
      {error && <p className="status-message error">Error: {error}</p>}
    </div>
  );
};

export default Login;